/**
* CookieUtil.js
* 
* Created on 31-jan-2014, 13:36:43
*
* @author Jeroen van Schooten for Ranj
**/
export default class CookieUtil {
	static setSessionCookie (name, value) {
		document.cookie = name + "=" + value;
	}

	static setCookie (name, value, expirationInDays) {
		//Standard expiration of 30 days.
		expirationInDays = (expirationInDays === null ? 30 : expirationInDays);

		var currDate = new Date();
		currDate.setTime(currDate.getTime() + (expirationInDays * 24 * 60 * 60 * 1000));
		var expiration = "expires=" + currDate.toUTCString();

		document.cookie = name + "=" + value + "; " + expiration;
	}

	static getCookie (name) {

		var cookieString = document.cookie.split(';');

		name = name + "=";

		for (var i = 0; i < cookieString.length; i++) {
			var cookie = cookieString[i].trim();
			if (cookie.indexOf(name) === 0)
				return cookie.substring(name.length, cookie.length);
		}

		return null;
	}

	static deleteCookie (name) {
		document.cookie = name + '=; Max-Age=-99999999;';
	}
}
